module.exports = __webpack_public_path__ + "nc_static/media/connectionAnalysis.7aa20501.svg";